import { DistributorContract } from './distributor-contract';
import { DistributorProduct } from './distributor-product';
import { Postcode } from './postcode';
export class Distributor
{
	id: number;
	distributorContracts: DistributorContract[];
	distributorProducts: DistributorProduct[];
	name: string;
	street: string;
	house_number: string;
	postcode: string;
	city: string;
	phone: string;
	fax: string;
	sales_email: string;
	delivery_email: string;
	show_id_name_deliverer_boss: boolean;
	preferred_postcode: Postcode;
	walkday: string;
	memo: string;
	has_active_contract: boolean;

	constructor()
	{
		this.distributorContracts = [];
		this.distributorProducts = [];
	}
}



// WEBPACK FOOTER //
// ./src/app/models/distributor.ts